var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 11",
    fill: "gray",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M10 5.996a.31.31 0 00-.313-.305H.312A.31.31 0 000 5.996c0 .169.14.306.312.306h9.375A.31.31 0 0010 5.996z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M4.908 1.502a.318.318 0 00-.442 0L.092 5.78a.3.3 0 000 .432l4.374 4.278c.122.12.32.12.442 0a.3.3 0 000-.432L.754 5.996l4.154-4.062a.3.3 0 000-.432z"
  }))));
}
export default SvgArrow;